var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.58,134.45C97,65.5,211.94,75.23,256.31,123.71s58.79,79.56,98.82,61.45,91.06-13.27,94,44.26S405.14,355,330.72,375.1s-74.41,91.34-172.92,77c-53.71-7.84-54.93-65.94-47.35-114S27,214.4,64.58,134.45Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.58,134.45C97,65.5,211.94,75.23,256.31,123.71s58.79,79.56,98.82,61.45,91.06-13.27,94,44.26S405.14,355,330.72,375.1s-74.41,91.34-172.92,77c-53.71-7.84-54.93-65.94-47.35-114S27,214.4,64.58,134.45Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Space--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.41,79.3c84-2.47,193.16,82.18,193,205.61-.07,66.7-102,168.48-204.56,155.14S73.08,340.28,66.36,270.34,108.14,83.05,235.41,79.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.24,111.34c-56.66-8.94-112.82,22.35-111.32,29.37s14.83,1.63,22.8,1.56-34.21,28.35-38.44,44.6,40.07-32.18,80-40,22.6-11.63,19.81-18,39.6-13.61,72.6,3.05,52.61,40.68,61.69,55C382.41,186.87,360.53,124.79,275.24,111.34Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.27,182.46c2.67-13.38,36.8-15.73,62.26,1.75s29.28,36.47,23.65,35.86,23.34,15.1,33.64,52.87-.58,81.61-33.64,106.11c0,0,21.73-22.39,17.8-63.3s-50.43-49.1-59.88-60.3-2.08-28,15.07-30.7,2.59-23.69-16-24.25-33,3.89-35.55.35-49.33,4.54-58.63,40.32-22.73,25.41-14.43,0,62.41-50.62,72.54-52.52S259.65,185.57,260.27,182.46Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,237.41c18.67-8.81-1.2,37.25,4.69,80.82s59,79,97.31,74.78,62.05-56,32.52-75.72c0,0,30,1.49,36.65,32.54s-9,58.94-31.77,60.55-34.68,16.29-43.25,16.07,3.11-4.73-1.68-10.91-38.91-.63-80.13-20-50.07-39.24-57.78-67,8.92,4.37,17.48-.9.67-19.14,1.69-32.7,7-26.54,15.1-17.49S139,241.65,148,237.41Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stars--inject-29"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "124.31 341.53 125.2 340.29 123.96 341.18 123.71 339.67 123.46 341.18 122.22 340.29 123.11 341.53 121.6 341.78 123.11 342.03 122.22 343.27 123.46 342.38 123.71 343.89 123.96 342.38 125.2 343.27 124.31 342.03 125.82 341.78 124.31 341.53",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.62 312.83 392.52 311.58 391.27 312.48 391.02 310.97 390.77 312.48 389.53 311.58 390.42 312.83 388.91 313.08 390.42 313.33 389.53 314.57 390.77 313.68 391.02 315.19 391.27 313.68 392.52 314.57 391.62 313.33 393.13 313.08 391.62 312.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.38 362.19 260.27 360.95 259.03 361.84 258.78 360.33 258.53 361.84 257.28 360.95 258.18 362.19 256.67 362.44 258.18 362.69 257.28 363.94 258.53 363.04 258.78 364.56 259.03 363.04 260.27 363.94 259.38 362.69 260.89 362.44 259.38 362.19",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.9 304.82 135.43 302.68 133.29 304.22 132.86 301.62 132.43 304.22 130.29 302.68 131.82 304.82 129.22 305.25 131.82 305.68 130.29 307.82 132.43 306.29 132.86 308.89 133.29 306.29 135.43 307.82 133.9 305.68 136.5 305.25 133.9 304.82",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.5 237.22 101.03 235.07 98.89 236.61 98.46 234.01 98.03 236.61 95.89 235.07 97.43 237.22 94.83 237.65 97.43 238.07 95.89 240.22 98.03 238.68 98.46 241.28 98.89 238.68 101.03 240.22 99.5 238.07 102.1 237.65 99.5 237.22",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.67 112.87 277.2 110.72 275.06 112.26 274.63 109.66 274.2 112.26 272.06 110.72 273.6 112.87 270.99 113.3 273.6 113.72 272.06 115.87 274.2 114.33 274.63 116.93 275.06 114.33 277.2 115.87 275.67 113.72 278.27 113.3 275.67 112.87",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.25 236.97 308.79 234.82 306.65 236.36 306.22 233.76 305.79 236.36 303.64 234.82 305.18 236.97 302.58 237.4 305.18 237.82 303.64 239.97 305.79 238.43 306.22 241.03 306.65 238.43 308.79 239.97 307.25 237.82 309.86 237.4 307.25 236.97",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.53 117.11 230.07 114.97 227.93 116.5 227.5 113.9 227.07 116.5 224.93 114.97 226.47 117.11 223.86 117.54 226.47 117.97 224.93 120.11 227.07 118.57 227.5 121.18 227.93 118.57 230.07 120.11 228.53 117.97 231.14 117.54 228.53 117.11",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.67 318.29 235.3 314.62 231.63 317.25 230.9 312.8 230.17 317.25 226.5 314.62 229.13 318.29 224.68 319.02 229.13 319.75 226.5 323.42 230.17 320.79 230.9 325.24 231.63 320.79 235.3 323.42 232.67 319.75 237.12 319.02 232.67 318.29",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.11 144.19 357.66 143.46 360.29 139.79 356.62 142.42 355.89 137.97 355.16 142.42 351.49 139.79 354.12 143.46 349.67 144.19 354.12 144.92 351.49 148.59 355.16 145.96 355.89 150.41 356.62 145.96 360.29 148.59 357.66 144.92 362.11 144.19",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.18 173.5 224.81 169.84 221.14 172.47 220.41 168.02 219.68 172.47 216.01 169.84 218.64 173.5 214.19 174.24 218.64 174.97 216.01 178.64 219.68 176.01 220.41 180.46 221.14 176.01 224.81 178.64 222.18 174.97 226.63 174.24 222.18 173.5",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.36 350.06 354.99 346.39 351.33 349.02 350.59 344.57 349.86 349.02 346.19 346.39 348.82 350.06 344.37 350.79 348.82 351.52 346.19 355.19 349.86 352.56 350.59 357.01 351.33 352.56 354.99 355.19 352.36 351.52 356.82 350.79 352.36 350.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.26 156.65 142.81 155.91 145.44 152.25 141.77 154.88 141.03 150.43 140.3 154.88 136.63 152.25 139.26 155.91 134.81 156.65 139.26 157.38 136.63 161.05 140.3 158.42 141.03 162.87 141.77 158.42 145.44 161.05 142.81 157.38 147.26 156.65",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.01 341.48 125.82 341.78 124.01 342.08 123.71 343.89 123.41 342.08 121.6 341.78 123.41 341.48 123.71 339.67 124.01 341.48",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.13 341.78 125.2 343.27 123.71 342.2 122.22 343.27 123.29 341.78 122.22 340.29 123.71 341.36 125.2 340.29 124.13 341.78",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.13,341.78a.42.42,0,1,1-.42-.42A.42.42,0,0,1,124.13,341.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.32 312.78 393.13 313.08 391.32 313.38 391.02 315.19 390.72 313.38 388.91 313.08 390.72 312.78 391.02 310.97 391.32 312.78",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.44 313.08 392.52 314.57 391.02 313.5 389.53 314.57 390.6 313.08 389.53 311.58 391.02 312.65 392.52 311.58 391.44 313.08",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.44,313.08a.42.42,0,0,1-.42.42.42.42,0,1,1,0-.84A.42.42,0,0,1,391.44,313.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.08 362.14 260.89 362.44 259.08 362.74 258.78 364.56 258.48 362.74 256.67 362.44 258.48 362.14 258.78 360.33 259.08 362.14",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.2 362.44 260.27 363.94 258.78 362.87 257.28 363.94 258.36 362.44 257.28 360.95 258.78 362.02 260.27 360.95 259.2 362.44",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.2,362.44a.42.42,0,0,1-.84,0,.42.42,0,1,1,.84,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.37 304.74 136.5 305.25 133.37 305.77 132.86 308.89 132.35 305.77 129.22 305.25 132.35 304.74 132.86 301.62 133.37 304.74",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.59 305.25 135.43 307.82 132.86 305.98 130.29 307.82 132.13 305.25 130.29 302.68 132.86 304.52 135.43 302.68 133.59 305.25",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.86,
    cy: 305.25,
    r: 0.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.98 237.13 102.1 237.65 98.98 238.16 98.46 241.28 97.95 238.16 94.83 237.65 97.95 237.13 98.46 234.01 98.98 237.13",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.19 237.65 101.03 240.22 98.46 238.37 95.89 240.22 97.73 237.65 95.89 235.07 98.46 236.92 101.03 235.07 99.19 237.65",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.19,237.65a.73.73,0,0,1-.73.72.72.72,0,0,1-.72-.72.73.73,0,0,1,.72-.73A.73.73,0,0,1,99.19,237.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.14 112.78 278.27 113.3 275.14 113.81 274.63 116.93 274.12 113.81 270.99 113.3 274.12 112.78 274.63 109.66 275.14 112.78",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.36 113.3 277.2 115.87 274.63 114.02 272.06 115.87 273.9 113.3 272.06 110.72 274.63 112.57 277.2 110.72 275.36 113.3",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274.63,
    cy: 113.3,
    r: 0.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.73 236.88 309.86 237.4 306.73 237.91 306.22 241.03 305.7 237.91 302.58 237.4 305.7 236.88 306.22 233.76 306.73 236.88",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.94 237.4 308.79 239.97 306.22 238.12 303.64 239.97 305.49 237.4 303.64 234.82 306.22 236.67 308.79 234.82 306.94 237.4",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306.22,
    cy: 237.4,
    r: 0.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.01 117.02 231.14 117.54 228.01 118.05 227.5 121.18 226.99 118.05 223.86 117.54 226.99 117.02 227.5 113.9 228.01 117.02",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.23 117.54 230.07 120.11 227.5 118.27 224.93 120.11 226.77 117.54 224.93 114.97 227.5 116.81 230.07 114.97 228.23 117.54",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227.5,
    cy: 117.54,
    r: 0.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.78 318.14 237.12 319.02 231.78 319.9 230.9 325.24 230.02 319.9 224.68 319.02 230.02 318.14 230.9 312.8 231.78 318.14",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.15 319.02 235.3 323.42 230.9 320.26 226.5 323.42 229.66 319.02 226.5 314.62 230.9 317.77 235.3 314.62 232.15 319.02",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.14,319a1.24,1.24,0,1,1-1.24-1.24A1.24,1.24,0,0,1,232.14,319Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.77 143.31 362.11 144.19 356.77 145.07 355.89 150.41 355.01 145.07 349.67 144.19 355.01 143.31 355.89 137.97 356.77 143.31",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.13 144.19 360.29 148.59 355.89 145.44 351.49 148.59 354.65 144.19 351.49 139.79 355.89 142.95 360.29 139.79 357.13 144.19",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.13,144.19a1.24,1.24,0,1,1-1.24-1.24A1.25,1.25,0,0,1,357.13,144.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.29 173.36 226.63 174.24 221.29 175.12 220.41 180.46 219.53 175.12 214.19 174.24 219.53 173.36 220.41 168.02 221.29 173.36",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.66 174.24 224.81 178.64 220.41 175.48 216.01 178.64 219.17 174.24 216.01 169.84 220.41 172.99 224.81 169.84 221.66 174.24",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.65,174.24a1.24,1.24,0,1,1-1.24-1.24A1.25,1.25,0,0,1,221.65,174.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.47 349.91 356.82 350.79 351.47 351.67 350.59 357.01 349.71 351.67 344.37 350.79 349.71 349.91 350.59 344.57 351.47 349.91",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.84 350.79 354.99 355.19 350.59 352.04 346.19 355.19 349.35 350.79 346.19 346.39 350.59 349.55 354.99 346.39 351.84 350.79",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.83,350.79a1.24,1.24,0,0,1-2.48,0,1.24,1.24,0,0,1,2.48,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.91 155.77 147.26 156.65 141.91 157.53 141.03 162.87 140.16 157.53 134.81 156.65 140.16 155.77 141.03 150.43 141.91 155.77",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.28 156.65 145.44 161.05 141.03 157.89 136.63 161.05 139.79 156.65 136.63 152.25 141.03 155.4 145.44 152.25 142.28 156.65",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.27,156.65a1.24,1.24,0,1,1-1.23-1.24A1.24,1.24,0,0,1,142.27,156.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.06 411.36 275.61 410.63 278.24 406.96 274.57 409.59 273.84 405.14 273.11 409.59 269.44 406.96 272.07 410.63 267.62 411.36 272.07 412.09 269.44 415.76 273.11 413.13 273.84 417.58 274.57 413.13 278.24 415.76 275.61 412.09 280.06 411.36",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.72 410.48 280.06 411.36 274.72 412.24 273.84 417.58 272.96 412.24 267.62 411.36 272.96 410.48 273.84 405.14 274.72 410.48",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.08 411.36 278.24 415.76 273.84 412.6 269.44 415.76 272.59 411.36 269.44 406.96 273.84 410.11 278.24 406.96 275.08 411.36",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.08,411.36a1.24,1.24,0,0,1-2.48,0,1.24,1.24,0,1,1,2.48,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 291.5 85.18 290.25 83.93 291.15 83.68 289.64 83.43 291.15 82.19 290.25 83.08 291.5 81.57 291.75 83.08 292 82.19 293.24 83.43 292.35 83.68 293.86 83.93 292.35 85.18 293.24 84.28 292 85.8 291.75 84.28 291.5",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.98 291.45 85.8 291.75 83.98 292.05 83.68 293.86 83.39 292.05 81.57 291.75 83.39 291.45 83.68 289.64 83.98 291.45",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.11 291.75 85.18 293.24 83.68 292.17 82.19 293.24 83.26 291.75 82.19 290.25 83.68 291.33 85.18 290.25 84.11 291.75",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1,291.75a.42.42,0,0,1-.42.42.42.42,0,0,1,0-.84A.42.42,0,0,1,84.1,291.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.36 267.49 205.25 266.24 204.01 267.13 203.76 265.62 203.51 267.13 202.27 266.24 203.16 267.49 201.65 267.73 203.16 267.98 202.27 269.23 203.51 268.33 203.76 269.85 204.01 268.33 205.25 269.23 204.36 267.98 205.87 267.73 204.36 267.49",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.06 267.44 205.87 267.73 204.06 268.03 203.76 269.85 203.46 268.03 201.65 267.73 203.46 267.44 203.76 265.62 204.06 267.44",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.18 267.73 205.25 269.23 203.76 268.16 202.27 269.23 203.34 267.73 202.27 266.24 203.76 267.31 205.25 266.24 204.18 267.73",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.18,267.73a.42.42,0,1,1-.84,0,.42.42,0,1,1,.84,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.33 213.45 164.23 212.21 162.98 213.1 162.73 211.59 162.48 213.1 161.24 212.21 162.13 213.45 160.62 213.7 162.13 213.95 161.24 215.19 162.48 214.3 162.73 215.81 162.98 214.3 164.23 215.19 163.33 213.95 164.84 213.7 163.33 213.45",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.03 213.4 164.84 213.7 163.03 214 162.73 215.81 162.43 214 160.62 213.7 162.43 213.4 162.73 211.59 163.03 213.4",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.16 213.7 164.23 215.19 162.73 214.12 161.24 215.19 162.31 213.7 161.24 212.21 162.73 213.28 164.23 212.21 163.16 213.7",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.15,213.7a.42.42,0,0,1-.42.42.42.42,0,1,1,0-.84A.42.42,0,0,1,163.15,213.7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Planets--inject-29"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 152.88,
    cy: 112.07,
    r: 12.72,
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.88,
    cy: 112.07,
    r: 12.72,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.19,113c1.58-.76,2.35-1.38,2.2-.52a9.11,9.11,0,0,0,0,2.25s.26.5,1,.28.71-.33,1-.33,2.48.05,1.82.88-.39,1.2-1,1.37-.83,1-.88,1.16a4.29,4.29,0,0,1-.65.71l-1.38.53a12.48,12.48,0,0,0,1.48,1.78,11.69,11.69,0,0,0,1,.89,2.71,2.71,0,0,1,1.21-.4c.71,0,.82.39,1.17.53s.31,0,.31,0,.33.41.69.22a6.23,6.23,0,0,1,1.84,0c.22,0,1.21-.44,1.65-.12s.55.23.6.62a3.08,3.08,0,0,1-.56,1.92,12.39,12.39,0,0,0,4-.28c-.53-.32-.28-2.36-.72-3.24s-.44-1.1-.28-1.48.5,0,.77,0a1,1,0,0,0,.83-.94,6.35,6.35,0,0,1,.27-1.26s.49-.93.72-.93a3.72,3.72,0,0,0,1.1-.06c.21-.11.21-.27.32-.56s.17-1.59-.11-1.53a1.82,1.82,0,0,1-.82-.22,6.3,6.3,0,0,0-1-.2c-.16,0-.22-.51-.22-.51s1-.61,1-.83-.38-.27-.43-.93.49-.66,1.09-.54,0,.26,0,.78.06.47.72,0,.49,0,.66,0a5.87,5.87,0,0,1,1,.17s-.06,1.35,0,2.72,2.08.06,2.69-.44c.29-.23,1.14-.12,1.92.28a12.68,12.68,0,0,0-2-9.93.14.14,0,0,1-.15,0c-.24-.11-1,.11-1.15,0s-.88.16-1.24,0a1.35,1.35,0,0,1-.66-1.18,7.06,7.06,0,0,0-.58-2c-.09-.24-.1-.35,0-.38a12.75,12.75,0,0,0-10.26-1.33c.47.8.82,1.71.33,2.11-1,.77-.43,1.42.24,2a.86.86,0,0,1,0,1.37c-.21.22-.6.77-.24,1s1.15.6.59.93-.23,1.15-1.17.44-.61-1.37-1.32-1.37-.82.82-1.76,1.1-1,.22-1.26.1-.27-.82-.88-1.42a.85.85,0,0,0-1.38.16c-.1.28-.28,1.56,0,1.72s0,1-.6,1.2-1.09-.71-1.29-.14a.49.49,0,0,0,0,.14s0,0,0,.06A12.39,12.39,0,0,0,140.19,113Zm13.09,6.18c-.88.22,0,0-.92-1s.52-.33.52-.33a12.81,12.81,0,0,0,.4-1.54c.11-.66.93,0,1.39,0s.92.66.38,1.54c0,0,0,.55-.38.44S154.16,118.91,153.28,119.13Zm-.4,1.49c.26-.17.89.22.79.93l-.83.22a4.09,4.09,0,0,1-.79-.71C151.81,120.74,152.62,120.78,152.88,120.62Zm-6.75-9.79c0-.55.17-1,.61-1,.71-.17.88.5,1.51.56s.36,1.73.36,1.73.22.85-.91.58-1.73-.06-1.84-.47S146.13,111.38,146.13,110.83Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.15,106.73a1.94,1.94,0,1,1-1.93-1.93A1.93,1.93,0,0,1,173.15,106.73Z",
    style: {
      fill: "#00ADB5",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.15,106.73a1.94,1.94,0,1,1-1.93-1.93A1.93,1.93,0,0,1,173.15,106.73Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.27,
    cy: 107.4,
    r: 0.39,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.14,106.62a.07.07,0,0,1-.07.07.07.07,0,1,1,0-.14A.07.07,0,0,1,172.14,106.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.07,108.18a.08.08,0,0,1-.07.07.07.07,0,1,1,0-.14A.08.08,0,0,1,171.07,108.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.76,105.12a.08.08,0,1,1-.15,0,.08.08,0,0,1,.07-.07A.08.08,0,0,1,171.76,105.12Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,106.81a.08.08,0,0,1-.08.07.07.07,0,0,1-.07-.07.08.08,0,0,1,.07-.08A.09.09,0,0,1,173,106.81Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,106.2a.07.07,0,0,1-.07.07.07.07,0,1,1,0-.14A.07.07,0,0,1,170,106.2Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,105.66a.25.25,0,0,1-.25.25.25.25,0,0,1,0-.5A.25.25,0,0,1,171,105.66Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.39,107.93a.25.25,0,1,1-.25-.25A.25.25,0,0,1,172.39,107.93Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.64,251.2A8.23,8.23,0,1,1,420.4,261,8.23,8.23,0,0,1,426.64,251.2Z",
    style: {
      fill: "#00ADB5",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.64,251.2A8.23,8.23,0,1,1,420.4,261,8.23,8.23,0,0,1,426.64,251.2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.81,255.61c-.15.24-.28-.09-.81.18a4.57,4.57,0,0,1-1.64.39l-.12.23c-.11.24-1.12-.15-1.12-.54s0,0,.78-.23,0,0,.07-.56-.22-.31-.54-.7a.52.52,0,0,0-.73-.1c-.24.14-.21.41-.44.47s-.13.2-.23.27-.26,0-.39,0-.3-.11-.38,0-.06.14-.08.2a1.15,1.15,0,0,1-.26,0c-.06,0-.13-.08-.13-.13a.25.25,0,0,1,0-.1,1,1,0,0,1,.17-.27.26.26,0,0,1,.29-.08.27.27,0,0,0-.08-.26h.32c.08,0,.31-.66.33-.76a.24.24,0,0,0-.11-.21c-.09-.05-.2,0-.31,0s-.34-.31-.55-.28a.52.52,0,0,0-.15.07l-.25.18a.31.31,0,0,0-.11.08.9.9,0,0,0,0,.16.13.13,0,0,1-.09.1c.19,0-.07.19-.11.2-.2.07-.59-.07-.82-.09a.16.16,0,0,1-.12,0,.25.25,0,0,1,0-.09c-.06-.14-.11-.29-.16-.43s-.16-.65.09-.79.53,0,.61-.26a.18.18,0,0,1,.05-.08c.07-.06.15.08.14.18a1.29,1.29,0,0,0,0,.48c.06.16.27.26.39.16-.08-.12.08-.26.22-.26s.3.07.43,0a.32.32,0,0,0,.14-.34.91.91,0,0,0-.17-.36.52.52,0,0,1-.51-.07c-.12-.09-.24-.25-.38-.19a1.46,1.46,0,0,0,.16-.21,2.36,2.36,0,0,0-.28-.12c-.09-.05-.18-.15-.13-.25a.16.16,0,0,1,.07-.07h0a6.84,6.84,0,0,1,1.56.23c-.16.3-.2.85.55,1.12,1.09.39,0,0,1-.54,0,0,0,0,0,0a8.11,8.11,0,0,1,2.14,1.48l-.44.32c-.46.31.15.47.15.47h.63c.34,0,.31,0,.33-.07A7.77,7.77,0,0,1,435.81,255.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.49,256.14a.48.48,0,0,1,0,.12c-.06.21-.37.14-.58.2-.44.14-.33.91-.76,1.11-.21.09-.46,0-.67.09a2.08,2.08,0,0,0-.38.35,1,1,0,0,1-.83.24,8,8,0,0,1,1.79-4.22.67.67,0,0,1,.24,0,.44.44,0,0,1,.29.36,1.42,1.42,0,0,1,0,.5l.32-.24a.31.31,0,0,1,.08.44c-.1.14-.3.16-.48.19s-.38.13-.39.3.1.27.19.38.18.28.1.4l.7-.41a.43.43,0,0,1,.13-.05A.27.27,0,0,1,423.49,256.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,255.05l-.06.19a.8.8,0,0,0,.55,0,.42.42,0,0,0,.15-.11.6.6,0,0,0,.12-.32,1.7,1.7,0,0,0,0-.45.48.48,0,0,0-.24-.36.29.29,0,0,0-.39.11c-.06.13,0,.29-.07.42s-.2.16-.24.27A.2.2,0,0,0,424,255.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.49,251.67c-.25.21-.65-.07-.95.07s-.24.29-.41.32a2.64,2.64,0,0,1-.28,0c-.1,0-.2.07-.19.16a.23.23,0,0,0,.07.11l.25.23a.7.7,0,0,1,.08.1.21.21,0,0,1-.14.27.54.54,0,0,1-.33,0,.65.65,0,0,1-.2-.05c-.06,0-.1-.13-.06-.19l.07-.07a.27.27,0,0,0,.08-.24.19.19,0,0,0-.19-.17l-.13.06-.43.26c-.2.11-.45.23-.65.13a.11.11,0,0,1-.09-.06s0-.08,0-.13a.29.29,0,0,0,0-.16,7.92,7.92,0,0,1,2.65-1.11,7.21,7.21,0,0,1,.93-.15h0v0C427.63,251.28,427.65,251.54,427.49,251.67Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.8,253.76a.17.17,0,0,0-.23.15l.1.16,0-.09c0,.09.11.18.19.11a.21.21,0,0,0,0-.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.43,256.12c-.13-.14-.36-.09-.56-.07s-.45-.08-.44-.27.21-.24.38-.25a.5.5,0,0,0-.52-.53.62.62,0,0,1,0,.5.3.3,0,0,1-.42.15c-.25-.19.06-.69-.18-.89a.48.48,0,0,0-.41,0c-.48.11-1,.28-1.19.74,0,.05-.4,0-.52,0s-.19.37-.21.5a.28.28,0,0,0,0,.22c0,.08.13.16.09.24s-.1.06-.14.11.26.5.36.55.38,0,.57.09a.44.44,0,0,1,.17.45l-.18,0a.58.58,0,0,1-.2.68.78.78,0,0,1,.71.22s.09.1.15.1a.22.22,0,0,0,.11-.05.86.86,0,0,0,.4-.54l.2,0c0-.11,0-.29-.12-.25s0,0-.07.06-.26,0-.27-.17a.62.62,0,0,1,.14-.36c.05-.06.09-.13.14-.2a.76.76,0,0,1,.42-.35c.31-.07.56.26.71.54.06.12.09.31,0,.33s-.14-.05-.19,0,0,.16-.1.21-.11,0-.16,0-.11.23,0,.35.15-.07.23-.12.38.08.56,0,.15-.15.22-.22.54-.23.57-.49-.1-.28-.13-.43S429.62,256.31,429.43,256.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.53,258.07a.51.51,0,0,0,.25,0c.12,0,.51.11.35.33s-.41-.25-.62-.13c.12,0,.11.23.05.35s-.13.27-.05.38c.16-.07.32.08.5.12s.45-.13.68-.09c0-.08,0-.17,0-.26s.17-.07.25-.13.18-.13.26-.07,0-.2,0-.29a1.51,1.51,0,0,1-.21-.23c-.05-.09,0-.23.06-.26s.19,0,.27,0a.21.21,0,0,0,.1-.19,1.85,1.85,0,0,1,0-.23h-.19a.16.16,0,0,1-.11.19.49.49,0,0,1-.24,0,1.36,1.36,0,0,0-.09-.69h-.25c0,.1-.11.16-.21.16a.55.55,0,0,1-.25-.13c-.05-.05-.11-.1-.18-.08s-.13.13-.12.23c0,.36-.15.27-.3.47A.4.4,0,0,0,423.53,258.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.7,261.53a1,1,0,0,1-.59-.08c-.08-.05-.18-.11-.27-.06a.23.23,0,0,0-.1.24c0,.08.09.16.12.25a.84.84,0,0,1,0,.74,1.41,1.41,0,0,1-1.12-.26.87.87,0,0,1-.09-.11c-.07-.16.15-.34.11-.5s-.35-.28-.25-.43.19-.06.28-.1a.21.21,0,0,0,.09-.29.53.53,0,0,0-.67.19c-.17,0-.22-.25-.23-.41s-.12-.4-.29-.34a.19.19,0,0,0-.11.15c-.13.38.18.74.46,1a.36.36,0,0,1,.14.23c0,.1-.06.21-.16.19l.35.39a.25.25,0,0,1,.05.13.18.18,0,0,1,0,.09,4.68,4.68,0,0,0-.27.4,7.59,7.59,0,0,1-.72-2,8.48,8.48,0,0,1-.19-1.93.59.59,0,0,1,.22-.2c.11,0,.24,0,.34-.06.25-.07.36-.39.61-.49a.51.51,0,0,1,.56.16.73.73,0,0,1,.12.61,1,1,0,0,0-.06.5c.1.29.46.32.76.31a.42.42,0,0,0,.23.45.3.3,0,0,0,.39-.25c.19,0,.43.12.43.32a.54.54,0,0,1-.22.3c-.08.1-.15.25-.07.35s.35,0,.42.17S423.83,261.51,423.7,261.53Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.22,267.27l-.26,0a.58.58,0,0,1,.05-.48c.11-.16.31-.27.4-.45a1.87,1.87,0,0,1,.16-.35c.17-.27.57-.25.89-.2a.31.31,0,0,1,.13-.42,1.22,1.22,0,0,1,.5-.08.62.62,0,0,0,.46-.14c0-.05.08-.12.14-.14h.14l.9.11c0-.22-.24-.34-.45-.36s-.46,0-.56-.22a1,1,0,0,1-1.14.43.1.1,0,0,1-.08,0c-.09-.12.22-.27.12-.37l-.43-.17c-.06,0-.13-.05-.16-.11s0-.22.09-.33-.05-.44-.11-.66,0-.54.25-.54c.05,0,.11,0,.15,0s.1-.16.12-.25c.06-.27.33-.43.56-.59a1.62,1.62,0,0,0,.19-.18,1.16,1.16,0,0,0,.36-.78,1.57,1.57,0,0,0-.49.47c-.16.18-.4.33-.61.22a.61.61,0,0,1-.41.66.59.59,0,0,1-.68-.36.23.23,0,0,1,0-.26.42.42,0,0,1,.25,0,.72.72,0,0,0,.66-.34.93.93,0,0,1-.78-.4.6.6,0,0,1,.19-.8l-.2,0a.65.65,0,0,1,.52-.49c.13,0,.25,0,.37,0a.28.28,0,0,0,.23-.25.44.44,0,0,1-.2-.42.45.45,0,0,1,.26-.31.16.16,0,0,1-.15-.13.23.23,0,0,1,.17-.22.69.69,0,0,1,.32,0,1.07,1.07,0,0,1,.71.34,1,1,0,0,1,.11.57c0,.26,0,.52,0,.78a.85.85,0,0,0,.23.7.66.66,0,0,0,.41.1,3,3,0,0,0,1.22-.25.93.93,0,0,0,.49-.4,1.14,1.14,0,0,0,.1-.61c0-.42.08-1.09-.35-1.35a.38.38,0,0,0-.41,0c-.08.06-.14.15-.23.18s-.29-.05-.41,0-.11.13-.17.21a.19.19,0,0,1-.23.1c-.09-.05,0-.2,0-.31s-.17-.43-.13-.65.25-.34.39-.5a2.11,2.11,0,0,0,.33-.49c.13-.06.28,0,.4.12a.42.42,0,0,0,.41.08c.11.14-.06.4.1.51l.07,0a.24.24,0,0,1,0,.17c0,.2.1.44.3.5,0,0,.07,0,.08,0s0,0,0-.06a1,1,0,0,0-.17-.75,1,1,0,0,1-.07-.15.28.28,0,0,1,0-.15.7.7,0,0,1,.06-.17.3.3,0,0,1,0-.1c.07-.06.17,0,.25,0a.6.6,0,0,0,.22-.09.39.39,0,0,1,.32,0c.07.24.14.49.2.74A8.23,8.23,0,0,1,430.22,267.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429,264.68a1.21,1.21,0,0,0,0,.5.85.85,0,0,1-.64.1.89.89,0,0,0,.44,1.11.51.51,0,0,1-.48.09,1.47,1.47,0,0,1-.42-.28l-1-.77c-.16.06-.06.31.1.39s.35.09.43.24,0,.45.09.61a1.61,1.61,0,0,0,.26.15.47.47,0,0,1,.17.49l0,.13a7.93,7.93,0,0,1-3.58-1.05l0,0a1.23,1.23,0,0,0,0-.19c0-.3.28-.5.51-.68a.9.9,0,0,0,.44-.72c-.39.1-.54.59-.87.8a1.2,1.2,0,0,1-.28.13,2.88,2.88,0,0,0-.47.3,7.91,7.91,0,0,1-2.07-2.05,1.11,1.11,0,0,0,.22-.75c.09-.11.23.09.36.1s.23-.19.38-.2.21.43.44.51.3-.13.46-.15.35.13.54.07c.55-.17.14-.77.22-1.11.05-.16.25-.19.38-.27a.71.71,0,0,0,.31-.58,2.4,2.4,0,0,0-.11-.66.69.69,0,0,1,.05-.63c.21-.23.62-.08.91-.23s.29-.43.5-.59a1.06,1.06,0,0,1,.65-.19.55.55,0,0,1,.18,0c.11.06.09.23.07.34a5.53,5.53,0,0,1-.31,1c.26.12.62.23.81,0a.7.7,0,0,1,.13-.17.37.37,0,0,1,.34,0c.09.2.19.39.29.57a1.17,1.17,0,0,0-1.17.76.5.5,0,0,1-.08.2.35.35,0,0,1-.28.12,2.67,2.67,0,0,1-.94-.31c-.32-.1-.77,0-.85.28.26-.09.48.18.73.28a1.63,1.63,0,0,0,.45.08,3.38,3.38,0,0,1,1.08.28.72.72,0,0,0,.45-.62,1.33,1.33,0,0,0,1.06.56,1.73,1.73,0,0,0,0,1c.12.24.36.46.35.73A.38.38,0,0,0,429,264.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.28,92.65a8.81,8.81,0,1,1-6.68,10.52A8.81,8.81,0,0,1,308.28,92.65Z",
    style: {
      fill: "#00ADB5",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.7,98.69a.91.91,0,1,0-.9-.9A.9.9,0,0,0,316.7,98.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.74,94.3a.91.91,0,0,0,1.81,0s0,0,0,0a9,9,0,0,0-1.24-.79A.91.91,0,0,0,313.74,94.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,102.7a1.39,1.39,0,1,0,1.39,1.39A1.4,1.4,0,0,0,304,102.7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.59,98.6a9.35,9.35,0,0,0-.51-1.27,1.1,1.1,0,0,0,0,.18A1.4,1.4,0,0,0,318.59,98.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.38,98.48a1.39,1.39,0,0,0-1-1.32,8.88,8.88,0,0,0-.89,2.63,1.51,1.51,0,0,0,.48.09A1.4,1.4,0,0,0,303.38,98.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.62,102.37a1.39,1.39,0,0,0,1,1.34A8.86,8.86,0,0,0,319,101,1.38,1.38,0,0,0,317.62,102.37Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,96.6A1.39,1.39,0,1,0,307.57,98,1.4,1.4,0,0,0,309,96.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.62,
    cy: 104.74,
    r: 0.9,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,105.2a.89.89,0,0,0,.63.85,8.87,8.87,0,0,0,.81-1.56.89.89,0,0,0-1.44.71Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.64,108.59a1.9,1.9,0,0,0,0,.25,8.91,8.91,0,0,0,2.53-2.24,2,2,0,0,0-2.56,2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.35,101.93a2.06,2.06,0,0,0-.9-1.7,8.87,8.87,0,0,0,.15,2.94c0,.09,0,.18.07.27A2,2,0,0,0,302.35,101.93Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.47,93.39s0-.07,0-.11a8.83,8.83,0,0,0-3.63,3.15,3.31,3.31,0,0,0,.55,0A3.09,3.09,0,0,0,306.47,93.39Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.66,93.84a2.07,2.07,0,0,0,1.81-1.1,8.88,8.88,0,0,0-3.71-.17A2,2,0,0,0,310.66,93.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.2,107.69a.91.91,0,1,0,.9.9A.9.9,0,0,0,310.2,107.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.25,109.34a.88.88,0,0,0-.68.32,9.92,9.92,0,0,0,1.53.33A.88.88,0,0,0,308.25,109.34Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.68,107.21a.9.9,0,0,0-.66.31,8.25,8.25,0,0,0,1.38,1.12.87.87,0,0,0,.19-.52A.91.91,0,0,0,304.68,107.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.05,99.71a.21.21,0,1,0-.21-.21A.22.22,0,0,0,315.05,99.71Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.27,96.33a.21.21,0,0,0,.21-.21.21.21,0,0,0-.21-.21.2.2,0,0,0-.2.21A.21.21,0,0,0,316.27,96.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.86,99.71a.21.21,0,1,0-.21-.21A.21.21,0,0,0,317.86,99.71Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.63,94.52a.2.2,0,0,0,.2-.2.2.2,0,0,0-.2-.21.21.21,0,0,0-.21.21A.2.2,0,0,0,310.63,94.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,98.28a.2.2,0,0,0-.2.2.2.2,0,0,0,.2.21.21.21,0,0,0,.21-.21A.2.2,0,0,0,308,98.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.59,104.09a.2.2,0,0,0-.21-.2.2.2,0,0,0-.2.2.2.2,0,0,0,.2.21A.21.21,0,0,0,306.59,104.09Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.17,101.73a.21.21,0,1,0,.21-.21A.21.21,0,0,0,303.17,101.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.24,102.72a.21.21,0,1,0,.21-.21A.21.21,0,0,0,312.24,102.72Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.24,
    cy: 100.18,
    r: 0.21,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.11,106.53a.2.2,0,0,0-.2.21.2.2,0,0,0,.2.2.2.2,0,0,0,.21-.2A.21.21,0,0,0,314.11,106.53Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.89,97.09a.21.21,0,0,0,0-.42.21.21,0,1,0,0,.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.29,96.8a.2.2,0,0,0,.21-.2.21.21,0,0,0-.21-.21.2.2,0,0,0-.2.21A.2.2,0,0,0,309.29,96.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.09,107.21a.21.21,0,1,0,.2.21A.21.21,0,0,0,309.09,107.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.6,104.74a.2.2,0,0,0-.21.2.21.21,0,0,0,.21.21.2.2,0,0,0,.2-.21A.2.2,0,0,0,308.6,104.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.58,105.9a.2.2,0,0,0-.2.21.2.2,0,0,0,.2.2.2.2,0,0,0,.21-.2A.21.21,0,0,0,303.58,105.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.58,109.29a.21.21,0,1,0,.21.21A.21.21,0,0,0,311.58,109.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.72,97.07a.48.48,0,1,0-.48-.47A.47.47,0,0,0,312.72,97.07Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.72,94.79a.48.48,0,1,0-.48-.47A.47.47,0,0,0,312.72,94.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.57,94.79a.48.48,0,0,0,0-1,.48.48,0,1,0,0,1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.58,107.21a.48.48,0,1,0-.48.48A.47.47,0,0,0,311.58,107.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.59,107.64a.48.48,0,1,0,.48.48A.48.48,0,0,0,306.59,107.64Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.89,
    cy: 106.31,
    r: 0.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.72,108.12a.48.48,0,1,0,.47.47A.47.47,0,0,0,312.72,108.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.5,102.21a.48.48,0,1,0-.48-.48A.49.49,0,0,0,309.5,102.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.27,103.67a.48.48,0,1,0-.47-.47A.47.47,0,0,0,316.27,103.67Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.37,101a.48.48,0,1,0,.47.47A.47.47,0,0,0,305.37,101Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.38,
    cy: 100.35,
    r: 0.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.91,370a50.65,50.65,0,0,1,5.24-11.19,48.43,48.43,0,0,1,3.23-4.63,52,52,0,0,1,10.53-10.24v0c.78-.56,1.52-1.08,2.33-1.6a42.35,42.35,0,0,1,5.23-3,36.81,36.81,0,0,1,3.5-1.62,50.22,50.22,0,0,1,5.24-1.88,54.06,54.06,0,0,1,7.23-1.59l0,0a56.32,56.32,0,0,1,9.15-.54A52.33,52.33,0,0,1,212.28,341s.05,0,.07,0a47.88,47.88,0,0,1,6.4,4.46c.95.76,1.86,1.55,2.75,2.37s1.8,1.74,2.66,2.66c.6.62,1.18,1.29,1.76,2,.74.87,1.45,1.77,2.12,2.72a51.46,51.46,0,0,1,4,6.17c.31.6.64,1.2.92,1.8a50.6,50.6,0,0,1,2.56,6.07q.45,1.25.81,2.52a52.51,52.51,0,0,1,2,12c.08,1.43.12,2.85.07,4.29,0,.73,0,1.45-.1,2.16-.08,1.14-.18,2.28-.32,3.4a53.33,53.33,0,0,1-1.34,6.77,38.65,38.65,0,0,1-1.34,4.28,45.68,45.68,0,0,1-2,4.94,51.4,51.4,0,0,1-4.95,8.3,44.78,44.78,0,0,1-3.59,4.45,52.85,52.85,0,0,1-4.72,4.63,55.48,55.48,0,0,1-5.5,4.16,51.65,51.65,0,0,1-7.63,4.18,50.5,50.5,0,0,1-6.13,2.3h0a50.46,50.46,0,0,1-5,1.26s0,0-.06,0a52.88,52.88,0,0,1-31.58-3.39h0c-1.4-.6-2.78-1.28-4.1-2-.94-.51-1.88-1.06-2.78-1.62-1.13-.69-2.19-1.43-3.25-2.2-.54-.41-1.08-.81-1.61-1.24a50.25,50.25,0,0,1-5.4-4.91,52.89,52.89,0,0,1-12.36-21,52.11,52.11,0,0,1-2.26-11.89c-.1-1.68-.15-3.4-.11-5.12a45.36,45.36,0,0,1,.36-4.83A49,49,0,0,1,134.91,370Z",
    style: {
      fill: "#00ADB5",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.91,370a50.65,50.65,0,0,1,5.24-11.19,48.43,48.43,0,0,1,3.23-4.63,52,52,0,0,1,10.53-10.24v0c.78-.56,1.52-1.08,2.33-1.6a42.35,42.35,0,0,1,5.23-3,36.81,36.81,0,0,1,3.5-1.62,50.22,50.22,0,0,1,5.24-1.88,54.06,54.06,0,0,1,7.23-1.59l0,0a56.32,56.32,0,0,1,9.15-.54A52.33,52.33,0,0,1,212.28,341s.05,0,.07,0a47.88,47.88,0,0,1,6.4,4.46c.95.76,1.86,1.55,2.75,2.37s1.8,1.74,2.66,2.66c.6.62,1.18,1.29,1.76,2,.74.87,1.45,1.77,2.12,2.72a51.46,51.46,0,0,1,4,6.17c.31.6.64,1.2.92,1.8a50.6,50.6,0,0,1,2.56,6.07q.45,1.25.81,2.52a52.51,52.51,0,0,1,2,12c.08,1.43.12,2.85.07,4.29,0,.73,0,1.45-.1,2.16-.08,1.14-.18,2.28-.32,3.4a53.33,53.33,0,0,1-1.34,6.77,38.65,38.65,0,0,1-1.34,4.28,45.68,45.68,0,0,1-2,4.94,51.4,51.4,0,0,1-4.95,8.3,44.78,44.78,0,0,1-3.59,4.45,52.85,52.85,0,0,1-4.72,4.63,55.48,55.48,0,0,1-5.5,4.16,51.65,51.65,0,0,1-7.63,4.18,50.5,50.5,0,0,1-6.13,2.3h0a50.46,50.46,0,0,1-5,1.26s0,0-.06,0a52.88,52.88,0,0,1-31.58-3.39h0c-1.4-.6-2.78-1.28-4.1-2-.94-.51-1.88-1.06-2.78-1.62-1.13-.69-2.19-1.43-3.25-2.2-.54-.41-1.08-.81-1.61-1.24a50.25,50.25,0,0,1-5.4-4.91,52.89,52.89,0,0,1-12.36-21,52.11,52.11,0,0,1-2.26-11.89c-.1-1.68-.15-3.4-.11-5.12a45.36,45.36,0,0,1,.36-4.83A49,49,0,0,1,134.91,370Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.91,370a25.92,25.92,0,0,1,5,.52c2.35.5,4.63,1.38,7,1.82,3,.54,6.11.38,9.14.72s6.21,1.3,8.23,3.62a177.94,177.94,0,0,0-22.1,2.51c-3.19.57-6.39,1.16-9.58,1.46A49,49,0,0,1,134.91,370Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.54,390.73a98.76,98.76,0,0,1,13.62-1,55.32,55.32,0,0,1,6.16.46c-.08,1.14-.18,2.28-.32,3.4l-.51,0A48.52,48.52,0,0,1,218.54,390.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.31,373.92a5.92,5.92,0,0,1,2.55-.12,59.08,59.08,0,0,0,10.3-.17c3-.24,5.93-.57,8.89-.88a35.32,35.32,0,0,0,6.8-1.18,27.17,27.17,0,0,1,3.71-1.1,15.62,15.62,0,0,1,4.71.29c2,.34,4,.65,6,1a52.51,52.51,0,0,1,2,12,21.25,21.25,0,0,1-4.06-.49c-2.28-.52-4.47-1.5-6.82-1.76-2.08-.22-4.19.12-6.28,0a37.18,37.18,0,0,1-6.54-1.24c-7.49-1.71-15.37-1.71-22.57-4.32A1.78,1.78,0,0,1,193.31,373.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.91,343.87c.78-.56,1.52-1.08,2.33-1.6a42.35,42.35,0,0,1,5.23-3,36.81,36.81,0,0,1,3.5-1.62c.24,0,.47.12.71.18a246.17,246.17,0,0,0,36.19,6.86c6.55.75,13.35,1.3,19.63,3.14.92.86,1.8,1.74,2.66,2.66a125.78,125.78,0,0,0-20.37-3.34c-5.85-.38-11.74-.1-17.56-.66-5.27-.49-10.51-1.68-15.79-1.4-1.17.07-2.34.19-3.52.26a44,44,0,0,1-11.72-1.18A12.8,12.8,0,0,1,153.91,343.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.26,352.12c5.2-1.07,10.61-.57,15.9-.07a123.12,123.12,0,0,0,18.31.75c1.82-.09,3.62-.28,5.45-.33.74.87,1.45,1.77,2.12,2.72a51.46,51.46,0,0,1,4,6.17c.31.6.64,1.2.92,1.8-.55-.07-1.08-.13-1.57-.17-3.12-.25-6.23-.48-9.32-.95a62.43,62.43,0,0,1-7-1.46,37.11,37.11,0,0,1-5.41-1.85c-1.48-.64-2.88-1.4-4.36-2a52.6,52.6,0,0,0-5.31-1.8C195.5,353.58,190.94,352.24,186.26,352.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.23,357c2.37-.55,4.85,0,7.22-.48.91-.18,1.76-.5,2.66-.73a18.94,18.94,0,0,1,3.93-.63,51.46,51.46,0,0,1,4,6.17,81.4,81.4,0,0,1-8.92-1.24c-1.63-.32-3.27-.68-4.89-1-.93-.21-4.17-.45-4.71-1.11C213.18,357.61,213.77,357.14,214.23,357Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.38,354.13a52.66,52.66,0,0,1,5.24-5.82,44.25,44.25,0,0,1,7.78,1.46,36,36,0,0,0,6.25,1.23c2.76.16,5.52-.42,8.29-.48s5.76.45,7.69,2.46c-3.58.22-7.17.46-10.75.67-6.23.36-12.46.61-18.71.58C147.24,354.22,145.31,354.2,143.38,354.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.76,342.67c-.38-.12-.92-.26-1.52-.4a42.35,42.35,0,0,1,5.23-3,53.58,53.58,0,0,0,8,1.42c4.48.47,9.3.47,13,3.11l-5.81-.63a50,50,0,0,0-11.65-.35,25.53,25.53,0,0,1-4.34.43A13.26,13.26,0,0,1,157.76,342.67Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.21,335.77a54.06,54.06,0,0,1,7.23-1.59l0,0a56.32,56.32,0,0,1,9.15-.54A52.33,52.33,0,0,1,212.28,341s.05,0,.07,0a47.88,47.88,0,0,1,6.4,4.46c-3.54,0-8.26-1.38-9.79-1.64-4-.69-8.07-1.39-12.09-2.14C187.94,340,179,338,170.21,335.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.46,334.16a56.32,56.32,0,0,1,9.15-.54A52.33,52.33,0,0,1,212.28,341a7.06,7.06,0,0,0-2.14-.26c-.69,0-1.38.23-2.08.33a17,17,0,0,1-2.67-.05,62.49,62.49,0,0,1-10-1.48c-3-.76-5.78-2-8.67-3A63,63,0,0,0,177.46,334.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.35,398.83c.38-.63,1.22-.78,1.92-1,2.94-.73,5.4-2.69,8.15-3.94,4.41-2,9.39-2.17,14.22-2.31a66.3,66.3,0,0,1,8.1.11,57.1,57.1,0,0,1,7,1.28c5,1.17,9.9,2.57,14.8,4,9,2.63,18,5.41,27.24,7.18a14.24,14.24,0,0,1,1.56.43,45.68,45.68,0,0,1-2,4.94c-3,.11-6.27-.49-9-.56-8.2-.24-16.29,1.82-24.15,4.21a30.3,30.3,0,0,1-7,1.57c-3.23.18-6.4-.73-9.49-1.63-3.6-1.08-7.2-2.16-10.77-3.27a35.16,35.16,0,0,1-5.51-2.1c-1.5-.81-2.89-1.81-4.35-2.7a26.79,26.79,0,0,0-7.6-3.05,6.37,6.37,0,0,1-2.41-.89A1.82,1.82,0,0,1,152.35,398.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.05,408.54a35.48,35.48,0,0,1-9.93.67,59.63,59.63,0,0,1-12.8-1.25,59.49,59.49,0,0,1-9.34-3.44c-1.83-.79-3.77-1.67-4.82-3.36,9.94-6,22.59-5.06,33.9-2.37,6.94,1.65,13.73,3.86,20.51,6.08-.61-.2-3.63,1.46-4.45,1.65a10.62,10.62,0,0,1-3.73,0C207,406.32,204.23,407.71,201.05,408.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.57,402.44a25.84,25.84,0,0,1,3.61.47c2.08.43,4.54,1.7,4.38,3.82,5-.07,10.41-.05,14.55,2.78-1.94.47-3.88.94-5.82,1.44l49.82,7.89a16.06,16.06,0,0,0,4.42.32c3.13-.29,5.84-2.23,8.89-3,3.75-.9,9.58-.09,13.92,1.67a44.78,44.78,0,0,1-3.59,4.45,52.85,52.85,0,0,1-4.72,4.63,55.48,55.48,0,0,1-5.5,4.16c-10.71-.91-21.2-3.84-31.58-6.76,3.86-.34,7.7-.68,11.56-1,2.12-.2,4.4-.43,6-1.83q-9.39-1.68-18.87-2.55c-3.58-.32-7.19-.56-10.79-.79q-9.27-.57-18.54-1.18a3,3,0,0,0-1.69.19,1.1,1.1,0,0,0-.5,1.47,1.43,1.43,0,0,0,1,.47l5.77,1.32c1.77.4,4,1.57,3.46,3.27-3.28,0-6.59-.11-9.89-.18-1.16,0-2.34,0-3.53-.1A52.89,52.89,0,0,1,134.57,402.44Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.33,428.34a37.7,37.7,0,0,1,8.36-.31c6.23.39,12.36,1.82,18.46,3.07a21,21,0,0,0,5,.6c1.88-.06,3.73-.62,5.62-.63,2.95,0,5.73,1.2,8.49,2.2,1.65.59,5.58,1.05,8.67,2a50.5,50.5,0,0,1-6.13,2.3h0a1.38,1.38,0,0,1-.16-.06,47.75,47.75,0,0,0-11.78-2.68c-8.73-1.24-17.53-2.45-26.31-1.81a12.8,12.8,0,0,0-2.53.39c-.94-.51-1.88-1.06-2.78-1.62-1.13-.69-2.19-1.43-3.25-2.2C153.4,429.17,152.86,428.77,152.33,428.34Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.2,424.08c4.68-2.43,10.21-2.35,15.55-1.78a52.85,52.85,0,0,1-4.72,4.63A46.26,46.26,0,0,1,209.2,424.08Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.09,435.41c7.8-1.36,15.83-.44,23.49,1.42a81.65,81.65,0,0,1,8.09,2,52.88,52.88,0,0,1-31.58-3.39Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.94,429.58c.52-.1,1.06-.14,1.59-.19,3.67-.32,7.46-.63,11,.33-2.53-.63-6,.79-9.36,2.06C156.06,431.09,155,430.35,153.94,429.58Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.56,380.6a45.36,45.36,0,0,0-.36,4.83c0,1.72,0,3.44.11,5.12a13.43,13.43,0,0,0,3.8.11c5.95-.43,11.88-.85,17.83-1.26-1.91-2.09-5.12-2.18-7.93-1.88s-5.82.83-8.35-.46a24.12,24.12,0,0,1,14.27-4.14c3.48.11,6.93,1,10.36.64,3-.29,6-1.53,9-1.19a24.42,24.42,0,0,1,4.28,1.09c15.18,4.39,32.24-4,47,1.69q-13.7,1.55-27.38,3c3.83,3.46,9.57,3.24,14.67,3.88a38.31,38.31,0,0,1,15.83,5.69,17.24,17.24,0,0,0,5.3,2.73,13.81,13.81,0,0,0,4.49,0c.4,0,.8-.09,1.2-.13a53.33,53.33,0,0,0,1.34-6.77c.14-1.12.24-2.26.32-3.4.06-.71.08-1.43.1-2.16.05-1.44,0-2.86-.07-4.29a52.51,52.51,0,0,0-2-12q-.36-1.28-.81-2.52c-3.67,0-7.39.44-11-.23-1.5-.28-3-.73-4.46-1a33,33,0,0,0-5.07-.37l-34.12-.77c-4.73-.11-9.43-.21-14.12-.76a106.07,106.07,0,0,1,32.05-2.91c1.68.1,3.48.21,4.92-.66-5.12-3.73-12.19-2.3-18.5-3-2.84-.29-5.63-1.06-8.49-1-2.62.06-5.19.76-7.79,1.07a49.81,49.81,0,0,1-8.46.08c-6.75-.29-13.52-.61-20.3-.91A50.65,50.65,0,0,0,134.91,370,49,49,0,0,0,132.56,380.6ZM158,363.24a26.79,26.79,0,0,1,6.53-.92l.78.78a18.62,18.62,0,0,1-11.18,1C155.4,363.78,156.67,363.51,158,363.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.52,389.59c-16.77,7.73-28.25,18.56-25.65,24.2s18.3,3.94,35.06-3.79,28.25-18.57,25.65-24.2S362.28,381.86,345.52,389.59Zm8.27,17.93c-14.67,6.76-28.27,8.51-30.39,3.91s8.05-13.8,22.71-20.56,28.26-8.52,30.39-3.92S368.45,400.76,353.79,407.52Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.52,389.59c-16.77,7.73-28.25,18.56-25.65,24.2s18.3,3.94,35.06-3.79,28.25-18.57,25.65-24.2S362.28,381.86,345.52,389.59Zm8.27,17.93c-14.67,6.76-28.27,8.51-30.39,3.91s8.05-13.8,22.71-20.56,28.26-8.52,30.39-3.92S368.45,400.76,353.79,407.52Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.92,390.46c-13.53,6.24-22.86,14.84-20.84,19.21s14.61,2.86,28.14-3.38,22.86-14.84,20.84-19.21S359.45,384.22,345.92,390.46Zm6.41,13.91c-11.83,5.45-22.75,7-24.4,3.42s6.62-10.88,18.45-16.34,22.75-7,24.4-3.42S364.16,398.91,352.33,404.37Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.92,390.46c-13.53,6.24-22.86,14.84-20.84,19.21s14.61,2.86,28.14-3.38,22.86-14.84,20.84-19.21S359.45,384.22,345.92,390.46Zm6.41,13.91c-11.83,5.45-22.75,7-24.4,3.42s6.62-10.88,18.45-16.34,22.75-7,24.4-3.42S364.16,398.91,352.33,404.37Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.32,391.33C335.7,396.23,328.38,403,330,406.42s11.48,2.24,22.1-2.66,17.94-11.64,16.36-15.08S356.94,386.44,346.32,391.33Zm5,10.92c-9.29,4.28-17.87,5.49-19.16,2.69s5.2-8.54,14.48-12.83,17.87-5.48,19.16-2.68S360.65,398,351.36,402.25Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.32,391.33C335.7,396.23,328.38,403,330,406.42s11.48,2.24,22.1-2.66,17.94-11.64,16.36-15.08S356.94,386.44,346.32,391.33Zm5,10.92c-9.29,4.28-17.87,5.49-19.16,2.69s5.2-8.54,14.48-12.83,17.87-5.48,19.16-2.68S360.65,398,351.36,402.25Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.22,
    cy: 399.79,
    r: 15.96,
    transform: "translate(-142.09 600.09) rotate(-70.92)",
    style: {
      fill: "#00ADB5",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.62,388.85v0a16,16,0,0,1,13.07-4.92c.38,0,.77.09,1.14.15a15.86,15.86,0,0,1,9.45,5.29c.27.32.53.64.77,1a15.64,15.64,0,0,1,1.84,3.2,12.78,12.78,0,0,1,.65,1.82,15.47,15.47,0,0,1,.6,5.62,1.46,1.46,0,0,1,0,.3c-.05.47-.1.92-.19,1.37a15.43,15.43,0,0,1-1.51,4.44,11.72,11.72,0,0,1-.87,1.5,16,16,0,0,1-14.78,7.12,15.45,15.45,0,0,1-5-1.33h0a1.88,1.88,0,0,1-.38-.18,14.62,14.62,0,0,1-4.08-2.81s-.09-.07-.13-.12a15.09,15.09,0,0,1-3.11-4.19,7.08,7.08,0,0,1-.5-1.09,7.66,7.66,0,0,1-.42-1.05,12.75,12.75,0,0,1-.47-1.74,15.61,15.61,0,0,1-.32-4.85A15.81,15.81,0,0,1,338.62,388.85Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.42,408.76a15.92,15.92,0,0,1-14.65,6.93,15.35,15.35,0,0,1-4.53-1.11C349.33,414.24,356.83,413.38,363.42,408.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.53,396.67c3.4-1.31,10.29-2.85,13.38-5.05a4.78,4.78,0,0,1,.38.65,35.58,35.58,0,0,0-4.81,4c-3.42,3.12-5.13,6-10.81,6.22S346.74,398.15,350.53,396.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.52,412.47c5-.63,17.06-2.78,25.32-9.3-.13.57-.29,1.12-.47,1.69-5.24,2.67-15,7.83-23.23,8.68A14.17,14.17,0,0,1,340.52,412.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.71,408.26a74,74,0,0,0,9.58-2c6.43-1.92,15.37-6.46,19.49-10a14.2,14.2,0,0,1,.37,2.77c-5.14,3.44-17.56,11-27.9,11.27A14.62,14.62,0,0,1,336.71,408.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.47,391.74a9,9,0,0,1,.74-1.18c4.82-1.43,14.1-3.65,18.33-5.8a13.31,13.31,0,0,1,1.86.79C352.13,386.76,341.2,390.63,336.47,391.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.23,394.3a48.51,48.51,0,0,1,11.28-2.23c2.58,0,10.22-3,12.92-5.3a5.24,5.24,0,0,1,.61.47c-6.62,2.79-14.69,9.68-18.41,11.68a40.78,40.78,0,0,1-7.2,3.07,14.85,14.85,0,0,1-.11-3.66A16.19,16.19,0,0,1,335.23,394.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M334.64,403.18a35.77,35.77,0,0,0,3.44-1c4.37-1.48,12.25-7.85,19.22-10.78,2.62-1.09,4.12-1.72,5-2.06.27.32.53.64.77,1a53.29,53.29,0,0,1-6.2,3.1c-4.44,1.86-9.18,4.38-11.91,6.66-2.09,1.73-7.37,4-9.83,4.84A12.75,12.75,0,0,1,334.64,403.18Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.53,406a102.09,102.09,0,0,1,12.21-2.25c6.92-.8,9.54-3.87,12.37-6.79a19.08,19.08,0,0,1,4.78-3.41,12.78,12.78,0,0,1,.65,1.82A48.18,48.18,0,0,1,355.09,402c-6.55,3.07-15.65,4.56-19.06,5.05A7.08,7.08,0,0,1,335.53,406Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.14,411.25a55.61,55.61,0,0,0,17.27-5.17c4.45-2.19,7.62-3.92,9.73-5.12a1.46,1.46,0,0,1,0,.3c-.05.47-.1.92-.19,1.37-5,2.67-16.56,8.18-26.66,8.74C339.22,411.36,339.18,411.3,339.14,411.25Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.62,388.83a16,16,0,0,1,13.07-4.92c.38,0,.77.09,1.14.15C349.43,385.64,343.12,388.22,338.62,388.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.35,414.18c4-.95,14.22-3.52,18.57-5.9a21.53,21.53,0,0,1,2.5-1.21,11.72,11.72,0,0,1-.87,1.5c-3.11,1.36-9.12,3.85-12.51,4.4-3,.48-5.68,1-7.29,1.39h0A1.88,1.88,0,0,1,343.35,414.18Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.85,386.83s-5.85,3.62-8.48,4.06a32.08,32.08,0,0,1-4.83.45S352,387,356.85,386.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.39,385.12A3.8,3.8,0,0,1,376.5,387c2.12,4.6-8.05,13.81-22.71,20.57s-28.27,8.51-30.39,3.91a3.76,3.76,0,0,1,0-2.79l-3.59,1.65a4.86,4.86,0,0,0,.08,3.5c2.6,5.64,18.3,3.94,35.06-3.79s28.25-18.57,25.65-24.2a4.8,4.8,0,0,0-2.61-2.33Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.39,385.12A3.8,3.8,0,0,1,376.5,387c2.12,4.6-8.05,13.81-22.71,20.57s-28.27,8.51-30.39,3.91a3.76,3.76,0,0,1,0-2.79l-3.59,1.65a4.86,4.86,0,0,0,.08,3.5c2.6,5.64,18.3,3.94,35.06-3.79s28.25-18.57,25.65-24.2a4.8,4.8,0,0,0-2.61-2.33Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,387.13a2.39,2.39,0,0,1,.75.9c1.64,3.57-6.62,10.88-18.45,16.34s-22.75,7-24.4,3.42a2.47,2.47,0,0,1-.2-1.16l-2.9,1.34a3.2,3.2,0,0,0,.25,1.7c2,4.37,14.61,2.86,28.14-3.38s22.86-14.84,20.84-19.21a3.16,3.16,0,0,0-1.13-1.29Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,387.13a2.39,2.39,0,0,1,.75.9c1.64,3.57-6.62,10.88-18.45,16.34s-22.75,7-24.4,3.42a2.47,2.47,0,0,1-.2-1.16l-2.9,1.34a3.2,3.2,0,0,0,.25,1.7c2,4.37,14.61,2.86,28.14-3.38s22.86-14.84,20.84-19.21a3.16,3.16,0,0,0-1.13-1.29Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.65,389.15a2.75,2.75,0,0,1,.19.28c1.29,2.8-5.19,8.54-14.48,12.82s-17.87,5.49-19.16,2.69a3.18,3.18,0,0,1-.09-.33l-2.34,1.08a2.25,2.25,0,0,0,.19.73c1.58,3.43,11.48,2.24,22.1-2.66s17.94-11.64,16.36-15.08a2.55,2.55,0,0,0-.42-.61Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.65,389.15a2.75,2.75,0,0,1,.19.28c1.29,2.8-5.19,8.54-14.48,12.82s-17.87,5.49-19.16,2.69a3.18,3.18,0,0,1-.09-.33l-2.34,1.08a2.25,2.25,0,0,0,.19.73c1.58,3.43,11.48,2.24,22.1-2.66s17.94-11.64,16.36-15.08a2.55,2.55,0,0,0-.42-.61Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rocket--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.14,248.45,53.39,250a6.75,6.75,0,0,0,1.15,5.09,5.62,5.62,0,0,0,4.05,2.09l2.6-5Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.19,252.18l-2.61,5A5.42,5.42,0,0,1,55.5,256a5,5,0,0,1-1-.91A6.68,6.68,0,0,1,53.39,250l3.75-1.51Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.19,252.18l-2.61,5A5.42,5.42,0,0,1,55.5,256Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.68,253.15,57.31,257s.8,3.17,3.87,3.35S65.42,259,65.42,259l.16-4.37Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.68,253.15,57.31,257s.8,3.17,3.87,3.35S65.42,259,65.42,259l.16-4.37Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.26,237.47c-4.36,4.45-10.14,20.91-9.88,23.13s-6.33,6.07-6.33,6.07L62.44,234s4.46-3.89,6.39-4.45,6,3.92,9.32,1.15S81.26,237.47,81.26,237.47Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.38,260.61c.15,1.23-1.83,3-3.61,4.27h0c-1.41,1-2.69,1.78-2.69,1.78L62.43,234s2.12-1.84,4.07-3.18a9.53,9.53,0,0,1,2.33-1.27c1.93-.57,6,3.92,9.31,1.15a2.32,2.32,0,0,1,.9-.49c1.2-.24,1.76,1.52,2,3.37v0a27.69,27.69,0,0,1,.21,3.88C76.9,241.92,71.13,258.38,71.38,260.61Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.38,260.61c.15,1.23-1.83,3-3.61,4.27,2.18-2.29,1.91-4.51,2.36-9.24s3.19-14,3.19-14a15.2,15.2,0,0,0-2.65-7.11c-1.56-2.4-3-3.48-4.17-3.7a9.53,9.53,0,0,1,2.33-1.27c1.93-.57,6,3.92,9.31,1.15a2.32,2.32,0,0,1,.9-.49l2,3.37v0a27.69,27.69,0,0,1,.21,3.88C76.9,241.92,71.13,258.38,71.38,260.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.13,248.46s23-24.64,26.12-26.55,5.4-1.25,5.4-1.25,4.21-1,5.53-.09.29,2.53-2.51,6.37c-5.19,7.12-27.12,28.74-27.12,28.74S57.25,254.28,57.13,248.46Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.82,225.33c-.33.49-.72,1-1.14,1.6-5.2,7.13-27.13,28.75-27.13,28.75s-7.31-1.4-7.41-7.23c0,0,23-24.63,26.12-26.53a9.12,9.12,0,0,1,3.32-1.28,5.2,5.2,0,0,1,2.07,0l.5-.12c.32-.06.76-.15,1.26-.23,1.32-.19,3-.3,3.77.25C95.3,221.39,94.72,222.63,92.82,225.33Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.16,226.71l-.53-.4a.91.91,0,0,1-.14-1.31c.84-1,2.21-2.84,2.09-4.36a5.2,5.2,0,0,1,2.07,0l.5-.12c.4,2.1-1.71,4.84-2.76,6A.9.9,0,0,1,85.16,226.71Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.82,225.33a6.67,6.67,0,0,1-2.41-5c1.32-.19,3-.3,3.77.25C95.3,221.39,94.72,222.63,92.82,225.33Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.68,250.32l-.12-.34a1.46,1.46,0,0,0,.92-.45c.36-.36.37-.66.18-.83-.51-.51-1.43,1.08-2.21.31-.32-.31-.35-.83.19-1.38a1.75,1.75,0,0,1,.85-.5l.14.34a1.39,1.39,0,0,0-.73.41c-.35.35-.36.65-.17.83.51.5,1.44-1.08,2.2-.33.33.32.35.85-.2,1.4A1.7,1.7,0,0,1,66.68,250.32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.53,245.17a1.06,1.06,0,0,1-.13,1.6l-.51.51.64.63-.3.3-2.09-2.06.8-.82A1.06,1.06,0,0,1,69.53,245.17Zm-.29.3c-.3-.29-.67-.26-1,.12l-.5.51.94.93.5-.51C69.51,246.13,69.53,245.77,69.24,245.47Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.31,244l-1.1,1.12.3.74-.3.31-1.17-3,.3-.3,3,1.1-.31.32Zm-.34-.13-1.48-.55.59,1.46Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.73,242.55a1.49,1.49,0,0,1,0-2.16,1.45,1.45,0,0,1,1.11-.48v.38a1.13,1.13,0,0,0-.83.35,1.13,1.13,0,1,0,1.61,1.58,1.09,1.09,0,0,0,.33-.84h.38a1.43,1.43,0,0,1-.46,1.13A1.48,1.48,0,0,1,72.73,242.55Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6,239.16l.26.26-1.5,1.52-2.09-2.06,1.45-1.48.26.26-1.16,1.18.65.63,1-1.05.25.25-1,1.05.68.67Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.26,236.73a1,1,0,0,1-.13,1.44,1.63,1.63,0,0,1-1,.52l-.1-.37a1.29,1.29,0,0,0,.84-.41c.31-.32.34-.64.12-.86s-.53-.23-1,.26l-.47.47-1-1.19,1.17-1.18.26.26-.92.93.52.62.23-.23C78.38,236.36,78.89,236.37,79.26,236.73Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.79,233.25l.21.2,1.06,2.71-.32.32-1-2.63-.94,1,.38.37-.28.29-.64-.62Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M81.44,229.07l.72-.75a.89.89,0,0,1,1.21-.06L85.48,230a.88.88,0,0,1,.06,1.3l-.78.8a.89.89,0,0,1-1.23,0l-2-1.82A.89.89,0,0,1,81.44,229.07Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Number--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.22,289.79l-10.29,2.78,3.6,13.3-7.5,2-3.6-13.3-30.08,8.15-1.46-5.42L151,254.42l8.35-2.26-17.27,41.36,20.8-5.63-3.18-11.75,7.27-2,3.18,11.75,10.29-2.78Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.13,274.77c-4.78-17.63,1.94-30.24,14.62-33.67s24.76,4.09,29.53,21.72-1.94,30.23-14.55,33.64S187.9,292.4,183.13,274.77Zm36.42-9.86C215.8,251.07,208,245.7,199.61,248s-12.5,10.85-8.75,24.69,11.51,19.21,20,16.91S223.29,278.75,219.55,264.91Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.51,261.82l-10.28,2.79,3.6,13.3-7.5,2-3.6-13.3-30.08,8.14-1.47-5.41,18.1-42.91,8.35-2.26-17.27,41.36,20.8-5.64L263,248.17l7.27-2L273.43,258l10.28-2.79Z",
    style: {
      fill: "#00ADB5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.44,231.34l1.32,4.84-20.2,5.47-7.06-26.09,19.71-5.33,1.31,4.84-13.71,3.71,1.53,5.67,12.11-3.28,1.27,4.69-12.11,3.28,1.64,6Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.18,230.38l-7-5.91-.3.09L159.63,226l2,7.27-6,1.63-7.06-26.09,11.29-3c7-1.89,12.31.55,13.89,6.4a8.78,8.78,0,0,1-3.13,9.68l8.12,6.81Zm-11.39-19.63-4.92,1.33,2.46,9.09,4.92-1.33c3.69-1,5.09-3.22,4.32-6.05S164.48,209.75,160.79,210.75Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.57,223l-7-5.91-.3.08L187,218.56l2,7.27-6,1.64-7.06-26.09,11.29-3.06c7-1.88,12.31.55,13.89,6.4a8.8,8.8,0,0,1-3.13,9.69l8.12,6.8Zm-11.39-19.64-4.92,1.33,2.46,9.1,4.92-1.33c3.69-1,5.09-3.22,4.32-6.05S191.87,202.33,188.18,203.33Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.17,207.45c-2.1-7.75,2.39-15.12,10.62-17.35s15.82,1.84,17.93,9.62-2.43,15.14-10.62,17.36S207.27,215.2,205.17,207.45Zm22.43-6.07a8.46,8.46,0,1,0-5.9,10.56A8.24,8.24,0,0,0,227.6,201.38Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.41,207l-7-5.91-.3.08-5.26,1.42,2,7.27-6,1.64-7.06-26.09L246,182.39c7-1.88,12.31.55,13.89,6.4a8.78,8.78,0,0,1-3.13,9.69l8.12,6.8ZM247,187.4l-4.92,1.34,2.46,9.09,4.92-1.33c3.69-1,5.09-3.22,4.32-6.05S250.71,186.41,247,187.4Z",
    style: {
      fill: "#00ADB5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.79,368.62H285.05a8.84,8.84,0,0,1-8.84-8.85v-15a8.84,8.84,0,0,1,8.84-8.84h28.4l7-8.9-1,8.9h8.39a8.84,8.84,0,0,1,8.85,8.84v15A8.85,8.85,0,0,1,327.79,368.62Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.14,351.55a5.07,5.07,0,1,1,5.09,4.88A4.86,4.86,0,0,1,287.14,351.55Zm8.78,0a3.71,3.71,0,1,0-3.69,3.67A3.58,3.58,0,0,0,295.92,351.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.51,352.71a3.75,3.75,0,1,1,3.76,3.69A3.59,3.59,0,0,1,298.51,352.71Zm6.18,0a2.43,2.43,0,1,0-4.86,0,2.43,2.43,0,1,0,4.86,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.31,352.71a3.51,3.51,0,0,1-3.66,3.69,3.07,3.07,0,0,1-2.52-1.17V359h-1.31V349.1h1.26v1.15a3.05,3.05,0,0,1,2.57-1.22A3.51,3.51,0,0,1,315.31,352.71Zm-1.33,0a2.43,2.43,0,1,0-2.44,2.55A2.39,2.39,0,0,0,314,352.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.2,355.56l.55-1a4.59,4.59,0,0,0,2.53.75c1.22,0,1.72-.36,1.72-1,0-1.62-4.56-.22-4.56-3.09,0-1.3,1.15-2.17,3-2.17a5.25,5.25,0,0,1,2.63.66l-.56,1a3.82,3.82,0,0,0-2.09-.57c-1.14,0-1.7.42-1.7,1,0,1.71,4.58.32,4.58,3.12,0,1.31-1.2,2.14-3.12,2.14A5.21,5.21,0,0,1,316.2,355.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.64,355.53a.87.87,0,0,1,.9-.87.87.87,0,0,1,0,1.74A.87.87,0,0,1,323.64,355.53Zm.13-8.75h1.53l-.25,6.53h-1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.89,246.78l31.92-2.31.28-1.25c1-4.92,4.78-23.4,4.19-35.15a24.72,24.72,0,0,0-.95-6.18c-3.9-12.12-42.18-36.55-42.18-36.55L339.29,180l22.5,28.18C354.88,223.76,347.89,246.78,347.89,246.78Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.89,246.78l31.92-2.31.28-1.25c1-4.92,4.78-23.4,4.19-35.15a24.72,24.72,0,0,0-.95-6.18c-3.9-12.12-42.18-36.55-42.18-36.55L339.29,180l22.5,28.18C354.88,223.76,347.89,246.78,347.89,246.78Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.16,287.11c-4,2.73-8,5.66-12,8.46-2,1.43-4,2.8-5.92,4.15s-3.92,2.64-5.66,3.67c-.42.26-.85.5-1.17.68s-.57.28-.51.32a1.42,1.42,0,0,1,.36,0h.09l-.1,0-.2,0-.82.15-1.69.31c-2.29.42-4.7.76-7.12,1.16-4.84.77-9.82,1.52-14.75,2.62l-.09,0a4.58,4.58,0,0,0-.12,8.9,103.06,103.06,0,0,0,15.35,2.55c2.59.25,5.21.38,7.92.43.68,0,1.35,0,2.06,0l1.05,0h.4l.32,0c.43-.06.86-.14,1.29-.22a23.85,23.85,0,0,0,3-.94c.83-.31,1.54-.62,2.24-.92,2.74-1.24,5-2.53,7.38-3.84s4.5-2.69,6.69-4.07c4.35-2.82,8.53-5.67,12.64-8.87A9,9,0,0,0,322.26,287Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.16,287.11c-4,2.73-8,5.66-12,8.46-2,1.43-4,2.8-5.92,4.15s-3.92,2.64-5.66,3.67c-.42.26-.85.5-1.17.68s-.57.28-.51.32a1.42,1.42,0,0,1,.36,0h.09l-.1,0-.2,0-.82.15-1.69.31c-2.29.42-4.7.76-7.12,1.16-4.84.77-9.82,1.52-14.75,2.62l-.09,0a4.58,4.58,0,0,0-.12,8.9,103.06,103.06,0,0,0,15.35,2.55c2.59.25,5.21.38,7.92.43.68,0,1.35,0,2.06,0l1.05,0h.4l.32,0c.43-.06.86-.14,1.29-.22a23.85,23.85,0,0,0,3-.94c.83-.31,1.54-.62,2.24-.92,2.74-1.24,5-2.53,7.38-3.84s4.5-2.69,6.69-4.07c4.35-2.82,8.53-5.67,12.64-8.87A9,9,0,0,0,322.26,287Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.93,304.39s6.47,9.73,5,15.56l2-.66s-.54-10.72-6.47-15.22Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.72,309.13l-8.67,1.08,5.23,8.16s7.67-1.43,6.77-5.36Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.27 315.59 262.15 321.08 267.28 318.37 262.05 310.21 255.27 315.59",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.72,309.13l-8.67,1.08,5.23,8.16s7.67-1.43,6.77-5.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.27 315.59 262.15 321.08 267.28 318.37 262.05 310.21 255.27 315.59",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270.72,309.13s3.55,4.33.6,8l1.17.48s4.71-3,.21-8.92Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.93,304.39s6.47,9.73,5,15.56l2-.66s-.54-10.72-6.47-15.22Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.72,309.13s3.55,4.33.6,8l1.17.48s4.71-3,.21-8.92Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,170.26l-1.46,8.5c0,.42-1.83,1.31-2.26,1.28h0l-9.63-.54a1.92,1.92,0,0,1-1.68-2.11c.57-4.2,1-6.18,1.72-11.48.4-3.26.87-9.74,2.11-14.11s5.53-3,5.39-1.07c-.32,4.65,1.93,11.3,3.95,14.61C341.5,165.92,343.11,169.59,343,170.26Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.86,170.79l-2.94,8.72c0,.42-1.19.56-1.62.53h0l-9.63-.54a1.92,1.92,0,0,1-1.68-2.11c.57-4.2,1-6.18,1.72-11.48.4-3.26.87-9.74,2.11-14.11s5.53-3,5.39-1.07c-.32,4.65,1.93,11.3,3.95,14.61C341.5,165.92,343.94,170.12,343.86,170.79Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.09,243.22c1-4.92,4.78-23.4,4.19-35.15C381.42,212.91,375,225,374,237.46,373.45,243.66,376.27,244.93,380.09,243.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.78,251.82s2.64-19,22.59-22.49c0,0,14.38-18.34,32.46-36.74l-9.67-50.37L405.61,137s22.2,37.77,18.92,62.44-39.8,59.67-39.8,59.67Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.78,251.82s2.64-19,22.59-22.49c0,0,14.38-18.34,32.46-36.74l-9.67-50.37L405.61,137s22.2,37.77,18.92,62.44-39.8,59.67-39.8,59.67Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.18,232.13a6.83,6.83,0,0,1-6.36,6.8l-24,1.67a6.83,6.83,0,0,1-7-4.77,6.72,6.72,0,0,1-.3-1.57c0-.16,0-.32,0-.48a6.82,6.82,0,0,1,6.35-6.8l24-1.67a6.84,6.84,0,0,1,7.28,6.34C383.17,231.81,383.18,232,383.18,232.13Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,230a6.83,6.83,0,0,1-6.35,6.8l-24,1.67a6.81,6.81,0,0,1-5.83-2.59,6.72,6.72,0,0,1-.3-1.57c0-.16,0-.32,0-.48a6.82,6.82,0,0,1,6.35-6.8l24-1.67a6.81,6.81,0,0,1,5.83,2.59,6.72,6.72,0,0,1,.3,1.57C382,229.63,382,229.79,382,230Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.82,261a17.16,17.16,0,0,0-12.15-16.11c-12.53-4.3-10.71,11.29-10.71,11.29l22.34,5.74Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.82,261a17.16,17.16,0,0,0-12.15-16.11c-12.53-4.3-10.71,11.29-10.71,11.29l22.34,5.74Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.88,245.84s12.63,3,15.18,13.34-15.16,33-22.53,37-36.83,7.87-40.33,3.66C311.14,285.34,337,261.81,345.89,256S370.88,245.84,370.88,245.84Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.2,299.86a2.38,2.38,0,0,0,.58.49c2.29,1.46,8.63,1.61,15.68,1,8.87-.77,18.87-2.73,23.35-4.81l.72-.35c5.69-3.11,17.56-17.35,21.49-28.42,1.16-3.26,1.62-6.25,1-8.6-2.55-10.32-15.18-13.34-15.18-13.34s-16.09,4.43-25,10.2S311.14,285.33,323.2,299.86Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.78,300.35c2.29,1.46,8.63,1.61,15.68,1,14.56-15.67,6.25-27.7,6.25-27.7C333.46,272.54,324.85,289.39,323.78,300.35Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.09,243.22S378,232.3,375.5,231s-29.22,1.07-32.64,2.36-21.9,17.45-23.14,22,4.36,16.38,4.36,16.38,19.12,3.82,26.92.57S378.08,249.2,380.09,243.22Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.08,271.73s19.12,3.81,26.92.56,27.09-23.08,29.08-29.07c0,0-2.13-10.92-4.58-12.26s-29.21,1.08-32.64,2.36-21.9,17.46-23.13,22a9.83,9.83,0,0,0,.1,4.19C320.82,264.82,324.08,271.73,324.08,271.73Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.83,259.53c2.59.49,19.4,3.51,26.59.51C354.21,256.78,373.5,237,375.5,231c-2.45-1.33-29.21,1.08-32.64,2.36s-21.9,17.46-23.13,22A9.83,9.83,0,0,0,319.83,259.53Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.61,
    cy: 279.24,
    r: 24.92,
    transform: "translate(-104.55 279.97) rotate(-41.15)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.61,
    cy: 279.24,
    r: 24.92,
    transform: "translate(-104.55 279.97) rotate(-41.15)",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,301.64a23.92,23.92,0,1,0-30.78-14A23.93,23.93,0,0,0,329,301.64Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 332.06,
    cy: 282.78,
    rx: 17.98,
    ry: 13.42,
    transform: "translate(-22.56 536.69) rotate(-76.02)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,291.76s4.66,4.59,6.05,3.44,4.08,2.39,6.33.38,6.66-7.88,4.43-13.4S324.49,283.49,324,291.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,291.76s4.67,4.59,6.05,3.44a1.45,1.45,0,0,1,1.44-.1c1.42.49,3.27,1.93,4.89.48,2.25-2,6.65-7.88,4.43-13.4-.95-2.37-4.09-2.46-7.41-1.15a17.35,17.35,0,0,0-2.59,1.29c-3.38,2.06-6.38,5.39-6.78,9C324.05,291.48,324,291.63,324,291.76Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,291.76s4.67,4.59,6.05,3.44a1.45,1.45,0,0,1,1.44-.1c5.55-3.32,3-11.27,1.91-14.07a17.35,17.35,0,0,0-2.59,1.29,51.1,51.1,0,0,0-6.78,9C324.05,291.48,324,291.63,324,291.76Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,291.38a2.83,2.83,0,0,0,.51,0c4.78-.23,3.45-9.8,1.13-15.27-1-2.42-2.43-3.53-3.7-3.59-1.62-.09-3,1.49-3.3,4.17-.18,1.8,1,4.27.8,5.47S309.73,291,314,291.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,291.38a2.83,2.83,0,0,0,.51,0c4.78-.23,3.45-9.8,1.13-15.27-1-2.42-2.43-3.53-3.7-3.59-1.62-.09-3,1.49-3.3,4.17-.18,1.8,1,4.27.8,5.47S309.73,291,314,291.38Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,291.38a2.83,2.83,0,0,0,.51,0c4.78-.23,3.45-9.8,1.13-15.27-1-2.42-2.43-3.53-3.7-3.59a8,8,0,0,0-1,.86c-1.59,1.57,0,7.67,0,9.27C310.83,284.12,311.38,289,314,291.38Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.13,275.2c1.84,7.22,3.28,11.36.86,16.11-3.65,7.15-13.48,6.63-17.45.09-3.57-5.89-6-16.71.08-21.69A10.28,10.28,0,0,1,331.13,275.2Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,280.53c.18.58,0,1.14-.35,1.26s-.84-.25-1-.83,0-1.14.35-1.26S320.78,280,321,280.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.42,282.57c.18.57,0,1.14-.35,1.26s-.84-.26-1-.84,0-1.14.35-1.25S314.23,282,314.42,282.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.59,282.21a21,21,0,0,1-1.28,5.63,3.57,3.57,0,0,0,2.9-.39Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.1,276.71a.4.4,0,0,1,.37,0,2.88,2.88,0,0,0,2.55.38.36.36,0,0,1,.47.19.34.34,0,0,1-.18.46,3.58,3.58,0,0,1-3.24-.44.36.36,0,0,1-.1-.49A.49.49,0,0,1,319.1,276.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.41,278.28a.37.37,0,0,1,.21,0,.35.35,0,0,1,.24.44,3.53,3.53,0,0,1-2.2,2.37.38.38,0,0,1-.45-.24.35.35,0,0,1,.24-.44,2.77,2.77,0,0,0,1.73-1.9A.32.32,0,0,1,312.41,278.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.64,291.05c-.16.11-.34.22-.52.32l-3.51-1.78s.13-.2.35-.49c.72-1,2.45-3.14,4-3a2.8,2.8,0,0,1,.52.13,2.73,2.73,0,0,1,1.5,1.17C326.45,288.29,326.14,289.51,323.64,291.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.5,286.28l-4.09,3-.45-.15c.72-1,2.45-3.14,4-3A2.8,2.8,0,0,1,324.5,286.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.64,291.05c-.67-1.47,1.16-2.9,2.36-3.6C326.45,288.29,326.14,289.51,323.64,291.05Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.82,295.25l-.31-.95c.92-.31,3.48-1.3,4.31-2.19a52.89,52.89,0,0,0,3.86-6.53l.89.47c-.12.22-2.88,5.52-4,6.74S323,295.2,322.82,295.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.87,295.44l1.05-.4a.71.71,0,0,0,.42-.91h0a.72.72,0,0,0-.92-.41l-1.05.39a.71.71,0,0,0-.41.91h0A.71.71,0,0,0,322.87,295.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.75,280.22a7,7,0,0,1-2.07,5c-1.77,1.73-3.87.42-4.38-1.87-.47-2.07-.11-5.45,2.16-6.32A3.21,3.21,0,0,1,335.75,280.22Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.85,272.22c2.2-.7,7.95-1.67,9.23-.5s3.95,15.17,6.81,16,7.9-3.87,7.48-8.11a9.5,9.5,0,0,0-3.06-6.3s-.76-11.14-12.37-10.28-14.43,10.36-14.27,13.68A12.21,12.21,0,0,1,314.85,272.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.85,272.22c2.2-.7,7.95-1.67,9.23-.5s3.95,15.17,6.81,16,7.9-3.87,7.48-8.11a9.5,9.5,0,0,0-3.06-6.3s-.76-11.14-12.37-10.28-14.43,10.36-14.27,13.68A12.21,12.21,0,0,1,314.85,272.22Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.89,258.14l1.54-.42a28.69,28.69,0,0,1,14.6-4.26c8.94-.27,22.11,7.83,24.34,23.52.09.6.15,1.15.19,1.66a12,12,0,0,1,.09,1.37v.05a11.13,11.13,0,0,1-.07,1.71c-.82,9.43-8.66,16.53-8.66,16.53a30.74,30.74,0,0,1-10.2,6.33L326,303.58c16.07-6.46,13.62-24.06,13.62-24.06l-5.46-10.33s-14.61-16.61-31.84-6.83l-.71-.62A30.78,30.78,0,0,1,305.89,258.14Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.58,261.74l.7.61c17.24-9.77,31.84,6.84,31.84,6.84l5.46,10.33S342,297.12,326,303.58l1.77,1.06a31.39,31.39,0,0,0,4.58-2.18,26.78,26.78,0,0,0,5.61-4.16s7.84-7.1,8.66-16.53a10,10,0,0,0,.07-1.71.13.13,0,0,1,0-.06c0-.47-.05-.92-.1-1.36s-.1-1.05-.19-1.66c-2.22-15.7-15.4-23.79-24.34-23.52a28.89,28.89,0,0,0-14.51,4.2l-.09.06-1.54.42A30.48,30.48,0,0,0,301.58,261.74Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.58,261.74l.7.61c17.24-9.77,31.84,6.84,31.84,6.84l5.46,10.33S342,297.12,326,303.58l1.77,1.06a31.39,31.39,0,0,0,4.58-2.18c4.32-3.86,11.49-15.85,8.29-22.39A65.22,65.22,0,0,1,336,267.83s-12.91-14.15-28.5-10.17c-.53.13-1.08.3-1.63.48A30.48,30.48,0,0,0,301.58,261.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.12,268c1.72-.64,3.72.05,5.4,1.63a7.59,7.59,0,0,1,3.53,9.45c-.23,2.29-1.28,4.12-3,4.77-2.9,1.08-6.57-1.59-8.21-6S332.23,269.12,335.12,268Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.12,268c1.72-.64,3.72.05,5.4,1.63a7.59,7.59,0,0,1,3.53,9.45c-.23,2.29-1.28,4.12-3,4.77-2.9,1.08-6.57-1.59-8.21-6S332.23,269.12,335.12,268Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.83,276.43c1.13,3,3.67,4.87,5.68,4.12s2.7-3.81,1.57-6.84-3.67-4.87-5.67-4.12S335.7,273.4,336.83,276.43Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.36,268.77a34.46,34.46,0,0,1,5.19,1.13,32.13,32.13,0,0,1,7.64-7.51s-2.68-1.26-7.8-.08A22.32,22.32,0,0,0,301.36,268.77Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.14,287.42a34.6,34.6,0,0,1,5.37-16c-1.64-.72-3.23-1.38-4.52-1.88C298.81,274.28,297.2,280.81,300.14,287.42Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.66,139.11l-10.21,6.58a.76.76,0,0,1-1.07-.18h0l-5.71-7.77a1.91,1.91,0,0,1,.55-2.63c3.6-2.24,5.44-3.13,10-6,2.77-1.77,8.06-5.53,12.22-7.36s5.86,2.34,4.26,3.48c-3.79,2.72-7.48,8.68-8.75,12.35A3,3,0,0,1,406.66,139.11Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.66,139.11l-10.21,6.58a.76.76,0,0,1-1.07-.18h0l-5.71-7.77a1.91,1.91,0,0,1,.55-2.63c3.6-2.24,5.44-3.13,10-6,2.77-1.77,8.06-5.53,12.22-7.36s5.86,2.34,4.26,3.48c-3.79,2.72-7.48,8.68-8.75,12.35A3,3,0,0,1,406.66,139.11Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.66 138.07 408.44 140.16 395.37 146.66 394.71 144.91 407.66 138.07",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,165s3.06,9.84-2.31,15.37l1.84,1.17s6.6-6.74,2.61-15.38Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.17,193.26l.4-2s8.61-5.86,20.23.48l0,4.28S415,189.13,404.17,193.26Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.35,199.25s-10.66,14.29-21,10l-.34-2s9.33,3.46,19.31-10.51Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.81,296.55l.72-.35c5.69-3.11,17.56-17.35,21.49-28.42-6,1.62-21.34,6.05-26.11,10.58C353.26,283.72,356,294.77,362.81,296.55Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,165s3.06,9.84-2.31,15.37l1.84,1.17s6.6-6.74,2.61-15.38Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.35,199.25s-10.66,14.29-21,10l-.34-2s9.33,3.46,19.31-10.51Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.66 138.07 408.44 140.16 395.37 146.66 394.71 144.91 407.66 138.07",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.17,193.26l.4-2s8.61-5.86,20.23.48l0,4.28S415,189.13,404.17,193.26Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.09,281.18a1.5,1.5,0,0,1-.73-2.81c3.67-2,5.63-4.59,6-7.85,1.15-9.9-12.65-22.5-12.79-22.63a1.5,1.5,0,1,1,2-2.22c.62.56,15.08,13.78,13.76,25.2-.49,4.23-3,7.64-7.54,10.12A1.46,1.46,0,0,1,380.09,281.18Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.33,287a1.51,1.51,0,0,1-1.26-2.32c9.78-15.11-8.61-28.56-9.4-29.12a1.5,1.5,0,1,1,1.75-2.44c.21.15,21.5,15.68,10.17,33.19A1.48,1.48,0,0,1,378.33,287Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.49,295.77c4.71-1.07,9.54-2.3,14.26-3.43,2.36-.59,4.71-1.13,7-1.66s4.62-1,6.62-1.32c.49-.08,1-.15,1.34-.19s.63-.06.59-.12A1.06,1.06,0,0,1,393,289l-.09,0,.1,0,.21,0,.81.16,1.69.34c2.28.46,4.64,1,7,1.56,4.78,1.07,9.69,2.22,14.68,3l.08,0a4.58,4.58,0,0,0,3.41-8.22,101.63,101.63,0,0,0-13.32-8.05c-2.31-1.2-4.69-2.29-7.19-3.33-.63-.27-1.25-.52-1.92-.75l-1-.36-.25-.09-.13,0-.31-.08c-.42-.1-.85-.19-1.28-.27a23,23,0,0,0-3.16-.25c-.89,0-1.66,0-2.42,0-3,.13-5.63.48-8.28.83s-5.18.83-7.72,1.3c-5.09,1-10,2.12-15,3.57a9,9,0,0,0,4.47,17.44Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.49,295.77c4.71-1.07,9.54-2.3,14.26-3.43,2.36-.59,4.71-1.13,7-1.66s4.62-1,6.62-1.32c.49-.08,1-.15,1.34-.19s.63-.06.59-.12A1.06,1.06,0,0,1,393,289l-.09,0,.1,0,.21,0,.81.16,1.69.34c2.28.46,4.64,1,7,1.56,4.78,1.07,9.69,2.22,14.68,3l.08,0a4.58,4.58,0,0,0,3.41-8.22,101.63,101.63,0,0,0-13.32-8.05c-2.31-1.2-4.69-2.29-7.19-3.33-.63-.27-1.25-.52-1.92-.75l-1-.36-.25-.09-.13,0-.31-.08c-.42-.1-.85-.19-1.28-.27a23,23,0,0,0-3.16-.25c-.89,0-1.66,0-2.42,0-3,.13-5.63.48-8.28.83s-5.18.83-7.72,1.3c-5.09,1-10,2.12-15,3.57a9,9,0,0,0,4.47,17.44Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.38,287l8.7-.8-3.36,9.08s-7.81.25-7.76-3.78Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.85 289.98 430.31 296.81 424.72 295.25 428.08 286.17 435.85 289.98",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.38,287l8.7-.8-3.36,9.08s-7.81.25-7.76-3.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.85 289.98 430.31 296.81 424.72 295.25 428.08 286.17 435.85 289.98",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M422.05,286.72s-4.78,2.5-3.35,7.39l-2-.17s-2.44-4.8,4.25-8.08Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,277.55s-13.33,10.9,1.41,18.41l-1.74.65s-8.05-.36-8.24-9.33C352.23,278.54,361,277.55,361,277.55Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.52,272.88s-4.59,5.94-2.19,16.17l-1.22.2a21.6,21.6,0,0,1,2-16.53Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.05,286.72s-4.78,2.5-3.35,7.39l-2-.17s-2.44-4.8,4.25-8.08Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,277.55s-13.33,10.9,1.41,18.41l-1.74.65s-8.05-.36-8.24-9.33C352.23,278.54,361,277.55,361,277.55Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.52,272.88s-4.59,5.94-2.19,16.17l-1.22.2a21.6,21.6,0,0,1,2-16.53Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.75,234.93l-20.23,19.39h-7.07L361,234.93S365.08,232.26,367.75,234.93Z",
    style: {
      fill: "#00ADB5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.75,234.93l-20.23,19.39a5.24,5.24,0,0,0-7.07,0L361,234.93S365.08,232.26,367.75,234.93Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.32,236.66a6.12,6.12,0,0,1-1,.55,5.36,5.36,0,0,1-1.88.42c-.74,0-1.3-.21-1.49-.64s.21-1.28,1-1.89a5.5,5.5,0,0,1,1.18-.66,4.79,4.79,0,0,1,1.67-.41c.84-.07,1.49.15,1.69.63S346.24,236,345.32,236.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.44,160.81l-.08-.5s2.34-.39,3.12-1.72l.43.25C297,160.38,294.54,160.79,294.44,160.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.53,162l-.26-.43a16,16,0,0,1,6.38-2.14l0,.5A15.62,15.62,0,0,0,294.53,162Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.51,162.37l-.22-.45c3.12-1.49,4.52-.75,4.58-.72l-.24.44S297.36,161,294.51,162.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.32,236.66a6.12,6.12,0,0,1-1,.55,5.36,5.36,0,0,1-1.88.42c-.09-.65-.23-1.53-.46-2.53a18.53,18.53,0,0,0-4.33-8.76c-6.68-6.81-14.69-7.35-23.17-7.91-8.11-.54-16.5-1.1-24.09-7.21-7.74-6.23-11.61-17.91-9.88-29.76,1.56-10.63,7.18-18.88,15.05-22.09l1.13,2.78c-6.87,2.8-11.81,10.18-13.21,19.75-1.58,10.81,1.87,21.4,8.79,27s14.41,6,22.41,6.55c8.66.58,17.63,1.18,25.12,8.81a21.29,21.29,0,0,1,5,9.79C345.05,235,345.21,235.92,345.32,236.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.32,236.66a6.12,6.12,0,0,1-1,.55,5.36,5.36,0,0,1-1.88.42c-.09-.65-.23-1.53-.46-2.53a18.53,18.53,0,0,0-4.33-8.76c-6.68-6.81-14.69-7.35-23.17-7.91-8.11-.54-16.5-1.1-24.09-7.21-7.74-6.23-11.61-17.91-9.88-29.76,1.56-10.63,7.18-18.88,15.05-22.09l1.13,2.78c-6.87,2.8-11.81,10.18-13.21,19.75-1.58,10.81,1.87,21.4,8.79,27s14.41,6,22.41,6.55c8.66.58,17.63,1.18,25.12,8.81a21.29,21.29,0,0,1,5,9.79C345.05,235,345.21,235.92,345.32,236.66Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/error404.b3457c6776c8dc8d48fad33fb4a62b61.svg";
export { ForwardRef as ReactComponent };